import { Button, Segment, Loader, Popup, Icon } from 'semantic-ui-react';
import React, { useEffect, useState,useRef } from 'react';
import '../../Courses/stylesheets/notificationHeader.css';
import '../../Courses/stylesheets/headerStyles.css';
import outsideClickDetector from '../../Shared Components/outsideClickDetector';
import axios from '../../axios';

export default function Notification(props) {
    const [notifications, setNotifications] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const wrapperRef = useRef(null);
    outsideClickDetector(wrapperRef,props.onClose);

    const notificationApi = () => {
        setIsLoading(true);
        axios.get(`notification/`)
        .then((res) => {
            let notificationsList = [];
            res.data.notificatons.map((item) => {
                let notification = {};
                notification["text"] = item.text;
                notification["timestamp"] = item.timestamp;
                notification["redirection_link"] = item.redirection_link;
                notificationsList.push(notification);
            })
            setNotifications(notificationsList);
            setIsLoading(false);
        })
        .catch((err) => {
            console.log(err);
            setIsLoading(false);
        })
    }

    useEffect(() => {
        notificationApi();
    }, [])

    return (
        
        <div className="notification custom-popup-container" ref={wrapperRef}>
        <div className="parent-notif">
            <p>Notifications</p>
            <p 
                className="archive-notif" 
                onClick = {
                    () => {
                        axios.get(`notification/archive/`)
                        .then((res) => {
                            setNotifications([]);
                        })
                        .catch((err) => {
                            console.log(err);
                        })
                    }
                }>
                Archive All
            </p>
        </div>
        <div className="outerNotifDiv">
            {isLoading && <Loader />}
            {isLoading === false && notifications.length != 0 && notifications.map((item) => (
                <Segment className="notification-segment">
                    <a href={item.redirection_link}>
                        <p dangerouslySetInnerHTML={{ __html: item.text }} className="notif"></p>
                    
                        <p className="timestamp">{item.timestamp}</p>
                    </a>
                </Segment>                
            ))}
            {isLoading === false && notifications.length === 0 && <p className="no-notifications">
                You have no new notifications
            </p>}
            
                                            
        </div>
        <div className="show-all-notif">
            <Button 
                secondary
                onClick={() => {
                    let url = window.location.href
                    let urlDetails = url.split("/");
                    window.open(`${urlDetails[0]}//${urlDetails[2]}/notifications`,"_self")
                }}
            >
                Show All
            </Button>
        </div>  
    </div>

    )
}
